import React, { useContext, useEffect, useState } from 'react';
import { authContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import useApiData from "../../services/useApiData.js"
import PostData from '../../services/PostData.js';
import { Button, TextField, InputAdornment, CircularProgress } from '@mui/material';
import { Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import SnackbarEx from '../Helpers/SnackbarEx.jsx';

export default function AddUser({ close }) {
    const { userRole } = useContext(authContext)
    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [submitSuccess, setSubmitSuccess] = useState(false)
    const { data: userAccounts, error: accountError, isLoading: loadAccounts, refetch: refetchAccounts } = useApiData("api/all-user-accounts/no3retailers");

    const navigate = useNavigate()
    const [userData, setUserData] = useState([
        { name: "firstName", label: "First Name", type: "text", value: "" },
        { name: "lastName", label: "Last Name", type: "text", value: "" },
        { name: "email", label: "Email", type: "text", value: "" },
        { name: "password", label: "Password", type: "password", value: "" }
    ])

    const initalState = userData.reduce(
        (acc, next) => ({ ...acc, [next.name]: next.value }),
        {}
    );
    const [initVals, setInitVals] = useState(initalState);


    const [showPassword, setShowPassword] = useState(false)
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleClose = () => {
        close(null)
    }

    const handleSubmit = async () => {
        setLoadSubmit(true)
        const submitUserData = { ...initVals, "business": "no3retailers", "role": "AppAdmin" }

        const { success, error, load } = await PostData({ data: submitUserData }, "create-user/analytics", null)
        if (error) {
            setOpenTestSnack({ color: "error", message: error?.response?.data ?? "An error has occurred.", open: true })
            setLoadSubmit(false)
        }
        if (success) {
            setLoadSubmit(false)
            setSubmitSuccess(true)
            setTimeout(() => {
                close("success")
            }, 500)
        }
    }


    return (
        <>
            <div className='card'
                style={{
                    width: "100%", height: '100%', border: 'none',
                    display: 'flex', flexDirection: 'column'
                }}>
                <div className='card-header d-flex justify-content-between align-items-center'
                    style={{ border: 'none', backgroundColor: 'white', borderBottom: 'solid lightgray', padding: '10px 15px' }}>
                    <h2 style={{ margin: '5px 0 0 0' }}>Create new account</h2>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            width: '40px', height: '40px',
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                            backgroundColor: 'white', zIndex: 100, "&:hover": { backgroundColor: '#f0f0f0' }
                        }}
                    >
                        <CloseIcon sx={{ cursor: 'pointer' }} />
                    </IconButton>
                </div>
                <div className='card-body'
                    style={{
                        marginTop: '10px', flexGrow: 1, gap: '10px',
                        display: 'flex', flexDirection: 'column', paddingLeft: '10px', paddingRight: "10px"
                    }}>
                    {userData.map((field) => (
                        <TextField
                            key={field.name}
                            onChange={(e) => {
                                setInitVals({ ...initVals, [field.name]: e.target.value });
                            }}
                            type={
                                field.name === "password" && showPassword
                                    ? "text"
                                    : field.type
                            }
                            value={initVals[field.name] || ""}
                            label={field.label}
                            InputProps={{
                                endAdornment: (
                                    field.name === "password" && (
                                        <InputAdornment position="end">
                                            {!showPassword ? (
                                                <VisibilityOffOutlinedIcon
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={handleClickShowPassword}
                                                />
                                            ) : (
                                                <VisibilityOutlinedIcon
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={handleClickShowPassword}
                                                />
                                            )}
                                        </InputAdornment>
                                    )
                                ),
                            }}
                        />
                    ))}
                </div>

                <div className='card-footer'
                    style={{
                        padding: '16px', borderTop: '1px solid #e0e0e0',
                        backgroundColor: 'white'
                    }}>
                    <Button
                        variant="contained"
                        sx={{
                            // background: '#1fb6ff',
                            boxShadow: 'none', borderRadius: '5px', minHeight: '36.5px',
                            backgroundColor: submitSuccess ? 'green' : '#3E5C76',
                            '&:hover': { backgroundColor: "#3e5c76f0", boxShadow: 'none' },
                            '&.Mui-disabled': {
                                color: 'white',
                                backgroundColor: submitSuccess ? 'green' : '#3E5C76',
                                opacity: 0.7
                            }
                        }}
                        fullWidth
                        disabled={loadSubmit || submitSuccess}
                        onClick={handleSubmit}
                    >
                        {loadSubmit ?
                            <CircularProgress size={20} color='white' />
                            :
                            submitSuccess ?
                                <> <CheckOutlinedIcon fontSize='small' sx={{ marginRight: '5px' }} /> <span>Success</span></>
                                :
                                "Create"
                        }
                    </Button>
                </div>
                {
                    openTestSnack.open && <SnackbarEx color={openTestSnack.color} message={openTestSnack.message} open={openTestSnack.open}
                        close={() => setOpenTestSnack({
                            color: "",
                            message: "",
                            open: false
                        })} />
                }
            </div>
        </>
    );
};